module.exports = __webpack_public_path__ + "static/media/text-picture-2.862e263a.png";